/**
 * Programme Responses component created by karora on 26/05/17.
 */
import {Component} from "@angular/core";

@Component({
  moduleId: module.id,
  selector: 'programme-responses',
  template: `<programme-detail></programme-detail><responses></responses>`,
  styleUrls: [],
  providers: [],
})


export class ProgrammeResponsesComponent {

  constructor(
  ) { }

}
